<template>
  <div class="main-header" id="head_top">
    <section class="left-header">
      <div @click="onClickMenu">ホーム</div>
      <div
        class="breadcumb"
        v-if="
          this.$route.path !== '/map' && this.$route.path !== '/orikomi_map'
        "
        v-html="getBreadcrumb()"
      ></div>
    </section>
    <section class="title">
      <h5 @click="onClickMenu">オリコミサービス自動見積システム</h5>
    </section>
    <section class="menu-burger">
      <img
        @click="sidemenu = !sidemenu"
        src="../assets/img/menu.svg"
        width="26"
        alt="menu"
      />
      <div v-if="sidemenu" @click="sidemenu = false" class="menu-bar">
        <div class="bar log" @click="(e) => e.stopPropagation()">
          <div style="display: flex; flex-direction: column; gap: 1rem">
            <div class="info">
              <h1 class="">
                {{ myAccount().company_name }}
              </h1>
              <h1 class="">
                {{
                  myAccount().user_name
                    ? myAccount().user_name.split(" ")[0]
                    : ""
                }}
              </h1>
            </div>

            <div @click="onClickMyAccount()" class="list">マイアカウント</div>
            <div @click="onClickMyCart()" class="list">カートの中身を確認</div>
            <div @click="onClickBlank()" class="list">よくある質問</div>
            <div @click="onClickFaq()" class="list">ご利用ガイド</div>
            <!-- <div @click="onClickFaq()" class="list">よくある質問</div> -->
          </div>
          <div @click="onClickLogout" class="list">ログアウト</div>
        </div>
      </div>
    </section>

    <div class="logged">
      <h5 class="min-14">
        {{ myAccount().company_name }}
      </h5>
      <h5 class="min-14" style="padding-right: 20px; color: #000">
        {{ myAccount().user_name ? myAccount().user_name.split(" ")[0] : "" }}
      </h5>
      <div class="account-div">
        <button class="" @click="onClickFaq()">
          <img class="account-img help" src="../assets/img/faq_2.svg" />
          <div class="thas faq">
            <span> ご利用ガイド </span>
          </div>
        </button>
        <button class="" @click="onClickBlank()">
          <img class="account-img help" src="../assets/help-circle.svg" />
          <div class="thas us">
            <span>よくある質問</span>
          </div>
        </button>
        <button class="" @click="onClickMyCart()">
          <img class="account-img help" src="../assets/img/shopping-cart.png" />
          <div class="thas cart">
            <span> カート </span>
          </div>
        </button>
        <button class="" @click="onClickMyAccount()">
          <img class="account-img help" src="../assets/img/user.png" />
          <div class="thas acc">
            <span>マイアカウント </span>
          </div>
        </button>
      </div>

      <span class="" @click="onClickLogout">ログアウト</span>
    </div>
  </div>
</template>

<script>
import { authStore } from "../store/auth-store";
import { accountStore } from "../store/account-store";
import { createDeviceDetector } from "next-vue-device-detector";
import backendApi from "@/apis/backend-api";
import { ref } from "vue";
import { mapModeStore } from "../store/map-mode-store";

const device = createDeviceDetector();
export default {
  name: "Header",
  props: {
    msg: String,
  },
  data() {
    return {
      accountStore,
      authStore,
      device,
      sidemenu: ref(false),
    };
  },
  async created() {
    const myAccountResponse = await backendApi.myAccountInfo();
    if (myAccountResponse.result == "success") {
      this.accountStore.commit("updateMyAccount", myAccountResponse.value);
    }
  },
  methods: {
    myAccount() {
      return this.accountStore.getters.myAccount;
    },
    onClickLogout() {
      mapModeStore.commit("clearMode");
      authStore.commit("clearToken");
      location.href = "/map";
    },
    onClickLogin() {
      authStore.commit("clearToken");
      this.$router.push("/login");
    },
    onClickRegister() {
      this.$router.push("/init_register");
    },
    onClickHome() {
      // location.href = "/";
      this.$router.push("/map");
    },
    onClickMenu() {
      this.$router.push("/");
    },
    onClickFaq() {
      location.href = "/term";
    },
    onClickBlank() {
      location.href = "/faq";
    },
    url: function (item) {
      console.log(item);
    },
    getBreadcrumb() {
      if (this.$route.path == "/map") {
        return " / マップ";
      } else if (this.$route.path == "/orikomi_map") {
        return " / オリコミマップ";
      } else if (this.$route.path == "/") {
        return " ";
      } else if (this.$route.path == "/cart") {
        return " / カート";
      } else if (this.$route.path == "/faq") {
        return " / よくある質問";
      } else if (this.$route.path == "/term") {
        return " / ご利用ガイド";
      } else if (this.$route.path == "/orders") {
        return " / ポスティング注文リスト";
      } else if (this.$route.path == "/orders_orikomi") {
        return " / オリコミ注文リスト";
      } else if (this.$route.path == "/orders_geenie") {
        return " / DSP配信注文リスト";
      } else if (this.$route.path.includes("/order_geenie")) {
        return "<span> / <a href='/orders_geenie' style='text-decoration:none;color:#fff;'>DSP配信注文リスト</a>/ 注文詳細</span> ";
      } else if (this.$route.path.includes("/order/")) {
        return "<span> / <a href='/orders' style='text-decoration:none;color:#fff;'>ポスティング注文リスト</a>/ 注文詳細</span>";
      } else if (this.$route.path.includes("/order_orikomi/")) {
        return "<span> / <a href='/orders_orikomi' style='text-decoration:none;color:#fff;'>オリコミ注文リスト</a>/ 注文詳細</span>";
      } else if (this.$route.path == "/accounts/manage") {
        return " / アカウントの管理";
      } else if (this.$route.path == "/myAccount") {
        return " / マイアカウント";
      } else if (this.$route.path == "/points") {
        return " <span>/ <a href='/myAccount' style='text-decoration:none;color:#fff;'>マイアカウント</a>/ ポイント履歴</span>";
      } else {
        return "";
      }
    },
    onClickMyAccount() {
      location.href = "/myAccount";
    },
    onClickMyCart() {
      location.href = "/cart";
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/base.css";
$baseColor: #2a7fff;
#hus {
  font-weight: bold;
  color: #fff;
}
#tooltext {
  text-align: start;
}
.main-header {
  width: 100%;
  height: 50px;
  background-color: $baseColor;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2rem;
  color: #fff;
  font-weight: bold;
  position: relative;
  .left-header {
    z-index: 10;
    display: flex;
    div:nth-child(1) {
      cursor: pointer;
    }
    .breadcumb {
      color: #fff;
      cursor: default;
    }
  }
  .title {
    z-index: 1;
    position: absolute;
    width: inherit;
    left: 0;
    top: 30%;
    h5 {
      cursor: pointer;
      width: max-content;
      margin: 0 auto;
      font-size: 1rem;
      font-weight: bold;
    }
  }
  .menu-burger {
    z-index: 10;
    display: none;
    img {
      cursor: pointer;
    }
    .menu-bar {
      position: fixed;
      width: 100%;
      height: calc(100vh - 50px);
      background-color: #0000007a;
      z-index: 9999;
      right: 0;
      top: 50px;
      .bar {
        width: 300px;
        height: 100%;
        background-color: #fff;
        position: absolute;
        right: 0;
        padding: 1rem;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        &.log {
          justify-content: space-between;
        }
        .info {
          text-align: left;
          color: #000;
          h1 {
            font-size: 1rem;
            font-weight: bold;
          }
        }
        .list {
          cursor: pointer;
          border: 1px solid #2a7fff;
          color: #2a7fff;
          font-weight: bold;
          text-align: left;
          padding: 0.5rem;
          border-radius: 0.2rem;
          &:hover {
            background-color: #c6d4e9;
          }
        }
      }
    }
  }
  .logged {
    z-index: 10;
    display: flex;
    align-items: center;
    h5 {
      font-weight: bold;
      font-size: 1rem;
      padding-top: 10px;
      padding-right: 1rem;
      &:first-child {
        color: black;
      }
    }
    .account-div {
      display: flex;
      gap: 1rem;
      padding-right: 1rem;
      button {
        background-color: $baseColor;
        .account-img {
          width: 22px;
          &.help:hover ~ .thas {
            display: flex;
          }
        }
        .thas {
          display: none;
          cursor: default;
          position: fixed;
          background-color: #fff;
          margin-top: 20px;
          margin-left: -170px;
          margin-right: 180px;
          border: 1px solid #c4c4c4;
          padding: 0.5rem;
          font-size: 0.8rem;
          border-radius: 0.2rem;
          flex-direction: column;
          text-align: start;

          &.faq {
            // background-color: red;
            margin-left: -50px;
            &::before {
              margin-left: 45px;
            }
          }
          &.cart {
            // background-color: red;
            margin-left: -15px;
            &::before {
              margin-left: 15px;
            }
            span:first-child {
              font-weight: bold;
              z-index: 10;
              width: max-content;
            }
          }
          &.acc {
            // background-color: red;
            margin-left: -50px;
            &::before {
              margin-left: 45px;
            }
            span:first-child {
              font-weight: bold;
              z-index: 10;
              width: max-content;
            }
          }
          &.us {
            margin-left: -40px;
            &::before {
              margin-left: 35px;
            }
            span:first-child {
              font-weight: bold;
              z-index: 10;
              width: max-content;
            }
          }
          span:first-child {
            font-weight: bold;
            z-index: 10;
          }
          &::before {
            position: fixed;
            content: "";
            margin-left: 160px;
            margin-top: -18px;
            width: 20px;
            height: 20px;
            transform: rotate(45deg);
            background-color: #fff;
            border-left: 1px solid #c4c4c4;
            border-radius: 0.2rem;
            border-top: 1px solid #c4c4c4;
          }
        }
      }
    }
    span {
      font-size: 1rem;
      cursor: pointer;
    }
  }
  .guest-nav {
    z-index: 10;
    display: flex;
    align-items: center;
    gap: 1rem;
    font-weight: bold;
    div {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      cursor: pointer;
    }
    button {
      background-color: $baseColor;
      .account-img {
        width: 22px;
        &.help:hover ~ .thas {
          display: flex;
        }
      }
      .trig:hover ~ .thas {
        display: flex;
      }
      .thas {
        display: none;
        cursor: default;
        position: fixed;
        background-color: #fff;
        margin-top: 20px;
        margin-left: -170px;
        margin-right: 100px;
        border: 1px solid #c4c4c4;
        padding: 0.5rem;
        font-size: 0.8rem;
        border-radius: 0.2rem;
        flex-direction: column;
        text-align: start;

        span:first-child {
          font-weight: bold;
          z-index: 10;
        }
        &::before {
          position: fixed;
          content: "";
          margin-left: 90px;
          margin-top: -18px;
          width: 20px;
          height: 20px;
          transform: rotate(45deg);
          background-color: #fff;
          border-left: 1px solid #c4c4c4;
          border-radius: 0.2rem;
          border-top: 1px solid #c4c4c4;
        }
      }
    }
  }
}

@media only screen and (max-width: 1440px) {
  .min-14 {
    display: none;
  }
}
@media only screen and (max-width: 1028px) {
  .main-header .left-header .breadcumb {
    display: none;
  }
  .main-header .logged {
    display: none;
  }
  .main-header .guest-nav {
    display: none;
  }
  .main-header .menu-burger {
    display: block;
  }
}

@media only screen and (max-width: 768px) {
  .main-header .title {
    display: none;
  }
}
</style>
